"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _safeMapAndCloneChildren = _interopRequireDefault(require("../utils/safeMapAndCloneChildren"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string
};

var Grid = function Grid(_ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  var classes = (0, _classnames["default"])('grv-grid', className);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, otherProps, {
    className: classes
  }), (0, _safeMapAndCloneChildren["default"])(children, function (child, index) {
    return {
      // one based index for odd/even
      className: (0, _classnames["default"])(child.props.className, "grv-row--" + (index % 2 ? 'even' : 'odd'))
    };
  }));
};

Grid.propTypes = propTypes;
var _default = Grid;
exports["default"] = _default;